import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { AppConfig } from 'client/app/app.config';
import { OrderService } from '@services/order-service/order.service';
import { Table } from '@cureskin/api-client';
@Component({
  selector: 'out-for-delivery',
  templateUrl: './out-for-delivery.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class OutForDeliveryComponent implements OnInit {

  private readonly orderService: OrderService = inject(OrderService);
  public readonly appConfig: AppConfig = inject(AppConfig);

  @Input('isRebrandingBanner') isRebrandingBanner: boolean;
  @Input('order') order: any;
  @Input() isPartialCancellationUIEnabled: boolean;
  @Output('addEvents') addEvents: EventEmitter<any> = new EventEmitter();
  orderedProductsCount: number;
  cancelledProducts: Array<Table.Order['attributes']['productApprovalDetails']['productDetails'][number]> = [];
  shouldShowPartialOrderCancellationUI: boolean;
  cancelledProductsCount: number = 0;
  totalProductsCount: number = 0;

  constructor() {}

  ngOnInit(): void {
    const approvalData = this.orderService.initializeProductApprovalData(this.order, this.isPartialCancellationUIEnabled);
    this.cancelledProducts = approvalData.cancelledProducts;
    this.orderedProductsCount = approvalData.orderedProductsCount;
    this.shouldShowPartialOrderCancellationUI = approvalData.shouldShowPartialOrderCancellationUI;
    this.cancelledProductsCount = approvalData.cancelledProductsCount;
    this.totalProductsCount = approvalData.totalProductsCount;
  }

  handleClick(): void {
    this.addEvents.emit();
  }
}
